<template>
    <div class="tabs">
        <template v-for="tab in tabs" :key="tab.key">
            <TabItem
                :title-key="tab.titleKey"
                :selected="modelValue === tab.key"
                @click="emit('update:modelValue', tab.key)"
            />
        </template>
        <pbl-button
            v-if="actionButton"
            class="tabs__action-button"
            compact
            @click="actionButton?.onClick()"
        >
            <pbl-icon
                slot="icon"
                variant="secondary"
                :name="actionButton?.icon"
            ></pbl-icon>
            {{ actionButton?.text }}
        </pbl-button>
    </div>
    <div class="tabs-content">
        <component :is="selectedTab?.tabComponent" :selected-tab="selectedTab?.key">
            {{ t(selectedTab?.titleKey ?? '') }}
        </component>
    </div>
</template>

<script setup lang="ts">
import TabItem from '@/components/tabs/TabItem.vue'
import { TabActionButton, TabItems } from '@/components/tabs/TabItems'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
    modelValue: number
    tabs: TabItems
    actionButton?: TabActionButton
}>()

const selectedTab = computed(() => {
    return props.tabs.find(tab => tab.key === props.modelValue)
})

const emit = defineEmits<{
    (e: 'update:modelValue', payload: number): void
}>()
</script>

<style scoped lang="scss">
.tabs{
    display: flex;
    gap: $spacing-s;
    padding-left: $spacing-3xs;
    padding-bottom: $spacing-2xs;

    &__action-button {
        margin-left: auto;
    }
}
.tabs-content {
    margin-top: $spacing-s;
}
</style>
